// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e7ba4e3","239":"f6497097","453":"18221e90","667":"83a1a6c2"}[chunkId] + ".chunk.js";
};